// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sq_a bhl_rc bhl_qx bhl_xr","ForumPosts__contest":"sq_b bhl_hq","ForumPosts__counselling":"sq_c"};